import axios, { AxiosResponse } from 'axios';
import { IGetFilesPayload } from '../../query/getFiles/useGetFiles.query';
export interface IGetFilesService extends IServiceWithAbort {
  payload: IGetFilesPayload;
}
export interface IServiceWithAbort {
  signal: AbortSignal;
}
interface GetBlobResponse {
  blobs: {
    name: string;
    path: string;
    type: string;
    id: string;
    slug: string;
    isFile: boolean;
  }[];
}
export default function getFilesService({ signal, payload }: IGetFilesService): Promise<AxiosResponse<GetBlobResponse>> {
  const url = '/api/getFiles';
  return axios.get(url, {
    signal,
    params: {
      path: payload.path,
      search: payload.search,
    },
  });
}
